import { useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { SiteId, AssetCameraKey } from "@visioni/a3s-schema";
import { deterrenceCommandMutation } from "./commands";
import type { CommandBody } from "../client-messages/commands";
import type { DeterrenceDevice } from "../g2-fleet-messages/commands";

/**
 * Fires the sirens/strobes wired to the asset behind a camera. The edge holds
 * them on for its activation duration, then switches them off by itself.
 */
export function useTriggerDeterrence() {
  const apiConfig = useApiConfig();

  const mutationConfig = useMemo(
    () =>
      apiConfig.tenant ?
        {
          tenantId: apiConfig.tenant.tenantId,
          apiBaseUrl: apiConfig.tenant.apiBaseUrl,
          authenticatedFetch: apiConfig.authenticatedFetch,
        }
      : { authenticatedFetch: apiConfig.authenticatedFetch },
    [apiConfig.tenant, apiConfig.authenticatedFetch],
  );

  return useMutation({
    mutationFn: ({
      siteId,
      cameraKey,
      devices,
    }: {
      siteId: string;
      cameraKey: string;
      devices: [DeterrenceDevice, ...DeterrenceDevice[]];
    }) => {
      const { mutationFn } = deterrenceCommandMutation(mutationConfig, {
        siteId: SiteId.fromString(siteId),
        assetCameraKey: AssetCameraKey.fromString(cameraKey),
      });
      return mutationFn({ action: "trigger", devices } satisfies CommandBody);
    },
  });
}
